<template>
  <div>
    <div
      class="w-100-vw h-100-vh bg-muted-50 position-fixed d-flex"
      style="left: 0; top: 0; z-index: 10000"
      v-if="$store.state.NProcess"
    >
      <loading-spinner :show="true" class="m-auto"></loading-spinner>
    </div>
    <AppSidebar />
    <div class="wrapper d-flex flex-column min-vh-100">
      <AppHeader class="max-md:tw-hidden" />
      <div class="body flex-grow-1">
        <CContainer fluid class="position-relative px-0">
          <router-view />
        </CContainer>
      </div>
      <!--      <AppFooter />-->
    </div>
  </div>
</template>
<script>
import { CContainer } from '@coreui/vue'
import AppHeader from '@/components/AppHeader.vue'
import AppSidebar from '@/components/AppSidebar.vue'
import LoadingSpinner from '@/components/loading/LoadingSpinner'

export default {
  name: 'NewAdminLayout',
  components: {
    LoadingSpinner,
    AppHeader,
    AppSidebar,
    CContainer,
  },
}
</script>
